namespace appn.views.brandCenter.index {

    class InitArgs {
        showModal: boolean = false;
    }

    export function init(args: InitArgs): void {
        const iosContainer = $('.widget-user-header.bg-brand-ios');
        const parentCard = iosContainer.closest('.card');
        const listingOptions = parentCard.find('select[id$="_SelectedListing"]');

        if (args.showModal)
            $('#checklistDialog').modal('show');

        $(document).on('click', '.replaceCertificateLink', function (e) {
            e.preventDefault();

            appn.dialog.confirm({
                modalColor: 'modal-danger',
                title: T('Replace Existing Certificate?'),
                message: T(`The existing code signing certificate will be <b>permanently deleted</b>.<br><br>Do you still want to proceed?`),
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function(result: any) {
                    if (result) {
                        const $form = $('form#appnForm');
                        $form.append('<input type="hidden" name="submitType" value="ResetCertificate" />');
                        $form.submit();
                    }
                }
            });
        });
        setABM(parentCard);
        listingOptions.on('change', function () {
            setABM($(parentCard));
        });
    }

    function setABM(parent: JQuery<HTMLElement>): void {
        const selectedListing = parent.find('select[id$="_SelectedListing"]');
        const abmDetails = parent.find('[data-my-identifier="ABM-Details"]');;
        const codes = parent.find('input[id$="redemptionCodesFile"]').closest('.row')

        if ((selectedListing.val() as string) === 'AppleBusinessManager') {
            abmDetails.showElement();
            codes.showElement();
        }
        else {
            abmDetails.hideElement();
            codes.hideElement();
        }
    }
}
